import { OpportunityKind } from 'anchor-scout-common/types';
export const ACTION_BI_NAME_BY_KIND = {
    [OpportunityKind.StalePrice]: 'pulse_action_stale_price',
    [OpportunityKind.RecurringAdhoc]: 'pulse_action_recurring_adhoc',
    [OpportunityKind.CrossSell]: 'pulse_action_cross_sell',
    [OpportunityKind.DiscountLeak]: 'pulse_action_discount_leak'
};
export const CONFIDENCE_BARS = [
    'shortBar',
    'middleBar',
    'tallBar'
];
const FILLED_BARS_BY_BAND = {
    high: 3,
    medium: 2,
    low: 1
};
export const filledConfidenceBars = (band)=>FILLED_BARS_BY_BAND[band];
